class ReadMore extends HTMLElement {
  constructor() {
    super();

    this.ACTIVE_CLASS = "read-more--active";

    this.isMobile = window.matchMedia("(max-width: 990px)").matches;
    this.toggle = this.querySelector(".js-truncate-toggle");
    this.content = this.querySelector(".read-more__content");
    this.height = undefined;
    this.truncation = this.dataset.truncation;
    this.truncationMobile = this.dataset.truncationMobile;

    this.init();
  }

  init() {
    this.setTruncationHeight();

    if (this.truncationHeight > 0) {
      this.addListener();
      this.setTruncatedHeight();

      this.content.classList.add("read-more__truncate")
      this.toggle.classList.add("read-more__button--active");
    }
  }

  setTruncationHeight() {
    const truncationMobile = this.truncationMobile > 0 ? this.truncationMobile : this.truncation;

    this.truncationHeight = this.isMobile ? truncationMobile : this.truncation;
  }

  setTruncatedHeight() {
    const lineHeight = getComputedStyle(this.content).lineHeight.replace("px", "");
    const height = this.truncationHeight * lineHeight;

    this.height = `${height}px`;
    this.content.style.height = this.height;
  }

  addListener() {
    this.toggle.addEventListener("click", () => this.toggleContent());
  }

  toggleContent() {
    this.classList.contains(this.ACTIVE_CLASS) ? this.reduceContent() : this.expandContent();
  }

  expandContent() {
    this.classList.add(this.ACTIVE_CLASS);

    const width = getComputedStyle(this.content).width;

    // Set properties to calculate height whilst hiding element
    this.content.style.width = width;
    this.content.style.position = 'absolute';
    this.content.style.visibility = 'hidden';
    this.content.style.height = 'auto';

    const height = getComputedStyle(this.content).height;

    // Reset properties used above to calculate height
    this.content.style.width = null;
    this.content.style.position = null;
    this.content.style.visibility = null;
    this.content.style.height = this.height;

    // Force repaint
    getComputedStyle(this.content).height;
    requestAnimationFrame(() => this.content.style.height = height);

    this.content.addEventListener("transitionend", () => {
      if (this.classList.contains(this.ACTIVE_CLASS)) this.content.style.height = "auto";
    });
  }

  reduceContent() {
    this.classList.remove(this.ACTIVE_CLASS);

    this.content.style.height = getComputedStyle(this.content).height;

    // Force repaint
    getComputedStyle(this.content).height;

    requestAnimationFrame(() => this.content.style.height = this.height);
  }
}

customElements.define("read-more", ReadMore);